import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download lista csv
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadListCsvReducer(state = initialState.crashboxxFiles.listCsv, action){

    switch(action.type)
    {
        case types.DOWNLOAD_LISTCSV_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_LISTCSV_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_LISTCSV_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadListCsvReducer.js